import React, { useEffect, useState } from "react";
import "./App.css";

// 학생 리스트
const students = [
  { id: 1, name: "Emily" },
  { id: 2, name: "Jason" },
  { id: 3, name: "Michael" },
  { id: 4, name: "Sophia" },
];

// 상태 + 색상
const STATUSES = [
  { key: "good", label: "Good", color: "#10b981" },
  { key: "ok", label: "OK", color: "#f59e0b" },
  { key: "low", label: "Needs Improvement", color: "#ef4444" },
];

// 연습 분야
const PRACTICE_FIELDS = [
  "Rhythm",
  "Scales",
  "Sight Reading",
  "Tone Control",
  "Dynamics",
  "Articulation",
];

// 랜덤 선택 유틸
function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function getRandomFields() {
  return PRACTICE_FIELDS.sort(() => 0.5 - Math.random()).slice(0, 2);
}

// 문장 생성
function generateSentence(name, statusKey, fields) {
  const templates = {
    good: [
      `${name} showed excellent progress in ${fields.join(" and ")}.`,
      `${name} played confidently, especially focusing on ${fields.join(" and ")}.`,
    ],
    ok: [
      `${name} made steady progress, though ${fields.join(" and ")} need more work.`,
      `${name} is improving, but ${fields.join(" and ")} require attention.`,
    ],
    low: [
      `${name} struggled with ${fields.join(" and ")} this week.`,
      `${name} needs extra practice on ${fields.join(" and ")} to improve.`,
    ],
  };
  return getRandom(templates[statusKey]);
}

export default function App() {
  const [studentIndex, setStudentIndex] = useState(0);
  const [currentStudent, setCurrentStudent] = useState(students[0]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [currentFields, setCurrentFields] = useState([]);
  const [currentSentence, setCurrentSentence] = useState("");
  const [report, setReport] = useState([]);
  const [loopMessage, setLoopMessage] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      // 🔹 이번 턴 학생 고정
      const student = students[studentIndex];
      setCurrentStudent(student);

      // 상태/연습분야/문장 생성
      const statusObj = getRandom(STATUSES);
      const fields = getRandomFields();
      const sentence = generateSentence(student.name, statusObj.key, fields);

      // 🔹 UI 먼저 업데이트
      setCurrentStatus(statusObj);
      setCurrentFields(fields);
      setCurrentSentence(sentence);

      // 🔹 보고서 누적
      setReport((prev) => [
        ...prev,
        { student: student.name, status: statusObj, fields, sentence },
      ]);

      // 🔹 루프 메시지 처리
      const isLast = studentIndex === students.length - 1;
      if (isLast) {
        setLoopMessage("✔ Weekly reports completed — restarting demo");
        setTimeout(() => setLoopMessage(""), 2500);
      }

      // 🔹 마지막에 인덱스 이동
      setStudentIndex(isLast ? 0 : studentIndex + 1);
    }, 4000);

    return () => clearTimeout(timer);
  }, [studentIndex]);

  return (
    <div style={{ padding: 24, fontFamily: "Arial" }}>
      <h2>🎵 Weekly Lesson Auto Demo</h2>

      {/* 학생 리스트 */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
        {students.map((s, i) => (
          <div
            key={s.id}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentStudent.id === s.id ? "#2563eb" : "#e5e7eb",
              color: currentStudent.id === s.id ? "#fff" : "#000",
              fontWeight: currentStudent.id === s.id ? "bold" : "normal",
            }}
          >
            {s.name}
          </div>
        ))}
      </div>

      {/* 상태 버튼 (자동 선택 연출) */}
      <div style={{ marginBottom: 16 }}>
        {STATUSES.map((s) => (
          <button
            key={s.key}
            disabled
            style={{
              marginRight: 8,
              padding: "6px 14px",
              borderRadius: 6,
              border: `2px solid ${s.color}`,
              background: currentStatus?.key === s.key ? s.color : "#f3f4f6",
              color: currentStatus?.key === s.key ? "#fff" : "#000",
              fontWeight: currentStatus?.key === s.key ? "bold" : "normal",
            }}
          >
            {s.label}
          </button>
        ))}
      </div>

      {/* 연습 분야 버튼 (자동 선택 연출) */}
      <div style={{ marginBottom: 16 }}>
        {PRACTICE_FIELDS.map((f) => {
          const selected = currentFields.includes(f);
          return (
            <button
              key={f}
              disabled
              style={{
                marginRight: 8,
                marginBottom: 6,
                padding: "6px 12px",
                borderRadius: 6,
                border: selected ? "2px solid #2563eb" : "1px solid #ccc",
                background: selected ? "#2563eb" : "#f3f4f6",
                color: selected ? "#fff" : "#000",
                fontWeight: selected ? "bold" : "normal",
              }}
            >
              {f}
            </button>
          );
        })}
      </div>

      {/* 문장 */}
      <div
        style={{
          background: "#f9fafb",
          padding: 16,
          borderRadius: 8,
          marginBottom: 16,
        }}
      >
        {currentSentence}
      </div>

      {/* 루프 메시지 */}
      {loopMessage && (
        <div
          style={{
            marginBottom: 16,
            padding: 12,
            background: "#111827",
            color: "#fff",
            textAlign: "center",
            borderRadius: 8,
            fontWeight: "bold",
          }}
        >
          {loopMessage}
        </div>
      )}

      {/* 보고서 */}
      <h3>📄 Generated Reports</h3>
      {report.map((r, i) => (
        <div
          key={i}
          style={{
            background: r.status.color,
            padding: 12,
            borderRadius: 8,
            marginBottom: 8,
            color: "#000",
          }}
        >
          <strong>{r.student}</strong> — {r.status.label}
          <br />
          <em>Focus:</em> {r.fields.join(", ")}
          <br />
          {r.sentence}
        </div>
      ))}
    </div>
  );
}
